export default {
  edit: {
    attributes: [
      {attribute: "locale"},
      {attribute: "name", translated: true}
    ]
  }
}
